import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faChevronLeft, faUnlockAlt } from '@fortawesome/free-solid-svg-icons'
import {
    sendPasswordResetEmail
} from "firebase/auth";
import { auth } from '../../firebase-config';
import Swal from 'sweetalert2'

export const RecoveryPasswordPage: React.FunctionComponent = () => {
    const mailIcon = <FontAwesomeIcon icon={faEnvelope} color='#67BAAF' />
    const lockIcon = <FontAwesomeIcon icon={faUnlockAlt} color='#000000' size="3x" />
    const back = <FontAwesomeIcon icon={faChevronLeft} color='#000000' />;

    const [email, setEmail] = useState('');

    const handleRecoveryPassword = async (e) => {
        e.preventDefault();

        try {
            await sendPasswordResetEmail(auth, email);
            setEmail('');
            Swal.fire('Correo de recuperación enviado!');
        } catch (error) {
            Swal.fire('Error!', error.message);
        }

    }

    return (
        <form className='flex flex-col justify-between items-center h-full absolute w-full pt-8 pb-8' onSubmit={handleRecoveryPassword}>

            <div className='fixed left-3 top-3'>
                <Link to="/auth/login"> <strong> {back}  </strong></Link>
            </div>

            <div className='w-full max-w-md p-8'>
                <div className='title_lg'>Recupera tu contraseña</div> <br />
                <div className='text-center'>
                    {lockIcon}
                </div>
            </div>
            <div className='w-full p-8 max-w-md'>

                <div className='w-full'>
                    Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un correo para restablecer tu contraseña.
                </div>

                <div className='w-full mt-4'>
                    <div className="flex items-center border-b border-teal-500 py-2">
                        {mailIcon}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" type="email" placeholder="Correo Electrónico*" aria-label="Email"
                            onChange={(e) => { setEmail(e.target.value) }} required />
                    </div>
                </div>

            </div>
            <div className='flex flex-col w-full p-8 max-w-md'>
                <button className="primary_btn hover:primary_btn text-white font-bold py-2 px-4 w-full" type='submit'>
                    Restablecer contraseña
                </button>
            </div>
        </form>
    )
}
